import React from "react";

const ShiftWeeklyOffsAssigment = () => {
    return <div>ShiftWeeklyOffsAssigment</div>;
};

export default ShiftWeeklyOffsAssigment;